/**
 * BBW · Blog index — Load More.
 * Progressive enhancement over the paginate `?page=N` link: fetches the
 * next page via the Section Rendering API, appends its cards to the grid,
 * and adopts that page's own Load More link (or removes the button on the
 * last page). Any fetch failure falls back to normal navigation.
 */
class BbwBlogList extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-bbw-more]');
      if (!button) return;
      event.preventDefault();
      this.#loadMore(button);
    });
  }

  /**
   * @param {HTMLAnchorElement} button
   */
  async #loadMore(button) {
    if (button.dataset.loading) return;
    button.dataset.loading = 'true';

    try {
      const url = new URL(button.href);
      url.searchParams.set('section_id', this.getAttribute('section-id'));

      const response = await fetch(url);
      if (!response.ok) throw new Error(`Failed to load page: ${response.status}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const cards = doc.querySelectorAll('[data-bbw-card]');
      const grid = this.querySelector('[data-bbw-grid]');
      if (!grid || cards.length === 0) throw new Error('No articles found in fetched page');

      grid.append(...cards);

      const nextButton = doc.querySelector('[data-bbw-more]');
      if (nextButton) {
        button.setAttribute('href', nextButton.getAttribute('href'));
        delete button.dataset.loading;
      } else {
        button.closest('.bbw-blog__more').remove();
      }
    } catch (error) {
      console.error('[bbw-blog-index]', error);
      window.location.href = button.href;
    }
  }
}

if (!customElements.get('bbw-blog-list')) {
  customElements.define('bbw-blog-list', BbwBlogList);
}
